import { isAllowedGitHubUrl } from './gitHubHelpers';

export function sanitizeMarkdownContent(markdown: string) {
  const markdownImagesSanitized = sanitizeMarkdownImages(markdown);
  return sanitizeHtmlImages(markdownImagesSanitized);
}

function sanitizeMarkdownImages(markdown: string) {
  // Example: ![Alt Text](https://example.com/image.png)
  // Captures: [1: alt ("Alt Text"), 2: url ("https://example.com/image.png")]
  const markdownImageRegex = /!\[([^\]]*)\]\((https?:\/\/[^)]+)\)/g;

  return markdown.replace(markdownImageRegex, (match, alt, url) => {
    if (isAllowedGitHubUrl(url)) {
      return match;
    }
    return `![${alt}](broken-image-link-blocked-org)`;
  });
}

function sanitizeHtmlImages(markdown: string) {
  // Example: <img src="https://example.com/image.png" alt="Test">
  // Captures: [1: url ("https://example.com/image.png")]
  const htmlImageRegex = /<img(?:[^>]*)src=["'](https?:\/\/[^"']+)["'](?:[^>]*)>/gi;

  return markdown.replace(htmlImageRegex, (match, url) => {
    if (isAllowedGitHubUrl(url)) {
      return match;
    }
    return `<!-- Blocked image from unauthorized GitHub org -->`;
  });
}
